import React from "react";
import "./styles.scss";
import "./mobile.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Popconfirm } from "antd";
import { useSelector } from "react-redux";
import { Button, ButtonIcon, FormHeader, Tag } from "..";

const GazetteViewCard = (props) => {
  const { tagsList } = useSelector(({ tagsReducer }) => tagsReducer);
  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-gazette-view-card-wrapper ${
          props?.isSelect ? "active" : ""
        } ${props?.cardType}`}
        onClick={props.onClickView}
      >
        <div className={`jvcmw__card`}>
          {!props.cardType && (
            <div className={"gvcw-logo"}>
              {/* <img src={require("../../assets/img/image 4.png")} alt={"job-img"} /> */}

              <div className={"gvcmw__news-date"}>
                <span
                  className={"tncmw__nd-day"}
                  style={{ marginRight: "10px" }}
                >
                  {moment(props?.gazetteDate).format("DD")}
                </span>
                <span className={"tncmw__nd-month"}>
                  {moment(props?.gazetteDate).format("MMM")}
                </span>
              </div>
            </div>
          )}
          <div className="d-flex flex-column">
            <div className={"gvcw__c-body"}>
              <div
                style={{
                  width: "100%",
                  paddingBottom: "16px",
                  gap: "8px",
                  // marginBottom: "px",
                }}
              >
                <div>
                  <FormHeader
                    data={{
                      formHeader: props?.titleEn,
                      lan: "en",
                      size: "xs xx",
                    }}
                  />
                  <FormHeader
                    data={{
                      formHeader: props?.titleSi,
                      lan: "si",
                      size: "xs",
                    }}
                  />
                </div>
              </div>
              <div className="gvcw-Tags-wrapper">
                <Tag
                  data={{
                    isIcon: false,

                    type: "gray",

                    // tagName: moment().isAfter(moment(props?.gazetteDate))
                    //   ? "Expired"
                    //   : moment(props?.gazetteDate).format("DD-MMM-YYYY"),
                    tagName: moment(props?.gazetteDate).format("DD-MMM-YYYY"),
                  }}
                />
                {/* <Tag
                data={{
                  isIcon: false,
                  type: "views_tag",
                  // tagName: data?.tags?.[0],
                  tagName: props?.organization,
                }}
              /> */}
                {Array.isArray(props?.organization) &&
                  props.organization.length > 0 && (
                    <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                      {props.organization.map((tagId, index) => {
                        const tagData = tagsList.find(
                          (t) => t.tag_id === tagId
                        );
                        return (
                          <Tag
                            key={index}
                            data={{
                              isIcon: false,
                              type: "gray",
                              tagName: tagData?.tag_name || "",
                            }}
                          />
                        );
                      })}
                    </div>
                  )}
                <Tag
                  data={{
                    isIcon: true,
                    tagIcon: "eye",
                    tagName: props?.views,
                    type: "views_tag",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {props?.isArrow && (
          <ButtonIcon
            data={{
              iconName: "h-wrrow-right",
              size: "xl",
              type: "light",
            }}
          />
        )}
      </div>
    </>
  );
};

export default withRouter(GazetteViewCard);
